import { useState } from 'react';
import { ConnectionPanel } from './ConnectionPanel';
import { ScopesPanel } from './ScopesPanel';
import { ScopeDetail } from './ScopeDetail';

/**
 * Migration from LogicMonitor (#15): connect, group devices into scopes, import
 * silently, tune, compare, then cut over per scope. Admin only (the API enforces).
 */
export function MigrationPage() {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div className="page">
      <h1 className="page-title">Migration</h1>
      <p className="text-muted">
        Move monitoring from LogicMonitor to Detect safely: Detect runs silently beside it until you cut over, per scope.
        Nothing here ever deletes anything in LogicMonitor.
      </p>
      <ConnectionPanel />
      <ScopesPanel selectedId={selectedId} onSelect={setSelectedId} reloadKey={reloadKey} />
      {selectedId && (
        <ScopeDetail
          key={selectedId}
          scopeId={selectedId}
          onChanged={() => setReloadKey((k) => k + 1)}
          onDeleted={() => {
            setSelectedId(null);
            setReloadKey((k) => k + 1);
          }}
        />
      )}
    </div>
  );
}
